import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import { patchUpdateVehicle } from "redux/actions/UserVehicle";
import { getCar } from "redux/actions/UserCar";
import MoreDetails from "components/moreDetails/MoreDetails";
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";
import { vehicleDialogData } from "pages/vendor/VendorBreadCrumbData";
import { subVendorVechileMatrix } from "pages/subVendor/vechileSubVendor/SubVendorVechileData";
import AminitiesVehicle from "./AminitiesVehicle";
import MatrixDriverVendor from "./MatrixDriverVendor";
import noCarImg from "assets/images/NoCarImg.svg";

function VehicleInfo(props) {
  const dispatch = useDispatch();
  const { vehicleInfo, vehicleImage, amenitiesVehicle } = props;
  const { state } = useLocation();
  const vehicleId = state?.vehicleId;
  const driverName = state?.driverId;
  const VehicelName = state?.name;
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const companyId = localStorage.getItem("companyId");
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  useEffect(() => {
    dispatch(getCar());
  }, []);

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const editVehicle = () => {
    setOpen(true);
    const updatedVehicleData = {
      ...vehicleData,
      fireExtinguisher: vehicleData?.fireExtinguisher?.toString(),
      firstAid: vehicleData?.firstAid?.toString(),
      stepney: vehicleData?.stepney?.toString(),
    };
    setDefaultValue(updatedVehicleData);
  };

  const editComplianceVehicle = () => {
    setOpen(true);
    const profileData = {
      vehicleId: props?.driverVehicleId || vehicleId,
      type: "vehicleRegistration",
    };
    setShowOtherComponent(true);
    dispatch(getOnBoardCompliance(profileData));
  };

  const onDialog = (data, code) => {
    const vehicleData = {
      ...data,
      carType: "COC",
      seating: parseInt(data?.seating),
      id: props?.driverVehicleId || vehicleId,
      type: "driver",
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(vehicleData).map((val) => {
      formData.append(val, vehicleData[val]);
    });
    dispatch(patchUpdateVehicle(formData));
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  const vehicleImages = vehicleImage?.filter(
    (val) => val.attributeType === "Multi-Image"
  );

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className="minHeight370"
      >
        <Grid item md={7.4} className="padding20 borderStyle">
          <div className="flexDirection">
            <Typography className="colorBlue font18 fontMedium">
              Vehicle Info
            </Typography>
            <Button
              variant="contained"
              className="vendorEditBtn"
              onClick={() => editVehicle()}
            >
              <span>
                <EditOutlinedIcon />
              </span>
            </Button>
          </div>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
          >
            {vehicleInfo?.map((ele, idx) => (
              <Grid
                item
                md={4}
                sm={6}
                xs={12}
                className="padding20 dashedBorder"
                key={ele.body}
              >
                <Grid item >
                  <div className="colorGrey font18 fontNormal">
                    {ele?.title}
                  </div>
                  <div className="font16 fontNormal">{ele?.body}</div>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item md={4.4} className="padding20 borderStyle">
          <div className="flexDirection">
            <Typography className=" font18 fontMedium paddingTop5 marginBottom7">
              {vehicleInfo[0]?.body || ""}
            </Typography>
          </div>
          {vehicleImages?.length === 0 ? (
            <Grid className="justifyCenter height100">
              <img src={noCarImg} alt="carimg" />
            </Grid>
          ) : (
            <>
              {vehicleImages?.length > 1 ? (
                <Carousel className="paddinginline30block40">
                  {vehicleImages.map((ele, idx) => (
                    <div key={ele.complianceFile?.url}>
                      <img
                        src={ele.complianceFile?.url}
                        className="height122 imageRendering"
                        alt="vehicelImage"
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                vehicleImages?.length > 0 && (
                  <div key={vehicleImages[0].complianceFile?.url}>
                    <img
                      src={vehicleImages[0]?.complianceFile?.url}
                      className="height235 width100 backgroundPrimary"
                      alt="vehicelImage"
                    />
                  </div>
                )
              )}
            </>
          )}
        </Grid>
      </Grid>

      <Grid className="padding20 borderStyle marginTop25">
        <Typography className="colorBlue font18 fontMedium mb10">
          Amenities
        </Typography>
        <AminitiesVehicle />
      </Grid>

      {driverName && (
        <div className="borderStyle marginBlock20 paddingTop10 padding20">
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Typography className="colorBlue font16 fontMedium">
                Vehicle Compliance
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                className="vendorEditBtn"
                onClick={() => 
                  editComplianceVehicle()
                }
              >
                <span>
                  <EditOutlinedIcon />
                </span>
              </Button>
            </Grid>
          </Grid>
          <MoreDetails details={props?.vehicleMoreData} />
        </div>
      )}
      {driverName && (
        <div className="padding20">
          <MatrixDriverVendor
            matrix={subVendorVechileMatrix(props?.vehicleMatrixData)}
          />
        </div>
      )}

      {open ? (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption,'edit')}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"edit"}
          type={"Edit " + "Vehicle" + " "}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={props?.driverVehicleId || vehicleId}
        />
      ) : null}
    </div>
  );
}

export default VehicleInfo;
